module.exports = __webpack_public_path__ + "img/Gaz_de_Bordeaux_80X30.cd30563d.png";